import SITE_LANGUAGE_LANDINGS from './siteLanguages.json';

export { SITE_LANGUAGE_LANDINGS };

export const SITE_LANGUAGE_CODES = SITE_LANGUAGE_LANDINGS.map((language) => language.code);

export const SITE_LANGUAGE_ALTERNATES = [
  { hrefLang: 'x-default', href: 'https://nowtarot.com/' },
  { hrefLang: 'en', href: 'https://nowtarot.com/' },
  ...SITE_LANGUAGE_LANDINGS.map((language) => ({
    hrefLang: language.code,
    href: `https://nowtarot.com${language.path}`,
  })),
];

export const LANGUAGE_SWITCHER_LINKS = SITE_LANGUAGE_LANDINGS.map((language) => ({
  href: language.path,
  flag: language.flag,
  label: language.nativeLabel,
}));

export const LANGUAGE_ANSWER_OPTIONS = [
  { value: '', label: 'Auto' },
  { value: 'en', label: 'English' },
  ...SITE_LANGUAGE_LANDINGS.map((language) => ({
    value: language.code,
    label: language.nativeLabel,
  })),
];
